<template>
  <v-snackbar
    v-model="showValue"
    :timeout="3000"
    color="info"
    location="bottom-center"
    :dir="$i18n.locale === 'he' ? 'rtl' : 'ltr'"
    class="custom-snackbar"
  >
    <div class="d-flex align-center">
      <v-icon class="mr-2">mdi-bell-remove</v-icon>
      <span>{{ message }}</span>
    </div>
    <template v-slot:actions>
      <v-btn variant="text" @click="close">
        {{ $t("close") }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: "AlertNotification",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: "",
    },
  },
  emits: ["close", "update:show"],
  computed: {
    showValue: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
/* Custom snackbar positioning */
.custom-snackbar {
  position: fixed !important;
  z-index: 9999;
  top: 20px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  margin: 0 20px !important;
  max-width: calc(100% - 40px) !important;
}
</style>
